export function dataInRequest(params = {}) {
  return {
    type: '@gerencias/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@gerencias/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@gerencias/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@gerencias/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@gerencias/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@gerencias/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@gerencias/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@gerencias/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@gerencias/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@gerencias/RECORD_FILTERING',
    payload: { params },
  };
}
